export const projectsItems = {
  filter: 'Filtrer',
};
